<p-confirmDialog key="reportinboxschedule" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="reportinboxscheduleconfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div>
	<h4 style="text-align: center">Schedule{{ SelectedJob == undefined ? " - Select a Job -" : "" }}</h4>
</div>
<div *ngIf="SelectedJob != undefined">
	<!--Menu Bar-->
	<div class="lock-to-top" style="background-color: #ffffff">
		<!--Buttons-->
		<div class="button-body flex">
			<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>
			<button
				[disabled]="IsLoading() == true || (SelectedJob != undefined && SelectedJob.CanEdit == false)"
				class="btn btn-primary"
				style="margin-left: 5px"
				(click)="onAdd()"
			>
				Add Schedule
			</button>
			<button
				[disabled]="IsLoading() == true || (SelectedJob != undefined && SelectedJob.CanEdit == false)"
				class="btn btn-primary"
				style="margin-left: 5px"
				(click)="onEdit()"
			>
				Edit Schedule
			</button>
			<button
				[disabled]="IsLoading() == true || (SelectedJob != undefined && SelectedJob.CanEdit == false)"
				class="btn btn-warning"
				style="margin-left: 5px"
				(click)="onToggle()"
			>
				{{ ToggleText }}
			</button>
			<button
				[disabled]="IsLoading() == true || (SelectedJob != undefined && SelectedJob.CanEdit == false)"
				class="btn btn-danger"
				style="margin-left: 5px"
				(click)="onDelete()"
			>
				Delete Schedule
			</button>
		</div>
	</div>

	<!--Table-->
	<div class="table-main-body">
		<p-table
			#mydt
			[value]="lstJobSchedule"
			[loading]="TableLoading"
			[paginator]="true"
			[(rows)]="pagerows"
			[(first)]="pagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="single"
			[(selection)]="SelectedJobSchedule"
			dataKey="JobScheduleID"
			(onRowSelect)="onRowSelect($event)"
			(onRowUnselect)="onRowUnselect($event)"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<!--RunTime-->
					<th>
						<p-columnFilter type="text" field="RunTimeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--RunMonDesc-->
					<th class="fixwidth-09">
						<p-columnFilter field="RunMonDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterRunMonDesc
									[ngModel]="value"
									[options]="lstRunMonDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--RunTueDesc-->
					<th class="fixwidth-09">
						<p-columnFilter field="RunTueDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterRunTueDesc
									[ngModel]="value"
									[options]="lstRunTueDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--RunWedDesc-->
					<th class="fixwidth-09">
						<p-columnFilter field="RunWedDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterRunWedDesc
									[ngModel]="value"
									[options]="lstRunWedDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--RunThuDesc-->
					<th class="fixwidth-09">
						<p-columnFilter field="RunThuDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterRunThuDesc
									[ngModel]="value"
									[options]="lstRunThuDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--RunFriDesc-->
					<th class="fixwidth-09">
						<p-columnFilter field="RunFriDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterRunFriDesc
									[ngModel]="value"
									[options]="lstRunFriDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--RunSatDesc-->
					<th class="fixwidth-09">
						<p-columnFilter field="RunSatDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterRunSatDesc
									[ngModel]="value"
									[options]="lstRunSatDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--RunSunDesc-->
					<th class="fixwidth-09">
						<p-columnFilter field="RunSunDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterRunSunDesc
									[ngModel]="value"
									[options]="lstRunSunDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>

					<!--ActiveDesc-->
					<th>
						<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
							<ng-template pTemplate="filter" let-value let-filter="filterCallback">
								<p-dropdown
									#filterActiveDesc
									[ngModel]="value"
									[options]="lstActiveDesc"
									(onChange)="filter($event.value)"
									placeholder="Any"
									[showClear]="true"
								>
									<ng-template let-value pTemplate="item">
										<span>{{ value }}</span>
									</ng-template>
								</p-dropdown>
							</ng-template>
						</p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<!--INSERT CUSTOM COLUMNS HERE-->
					<th pSortableColumn="RunTime">Time<p-sortIcon field="RunTime"></p-sortIcon></th>
					<th pSortableColumn="RunMonDesc" class="fixwidth-09">Monday<p-sortIcon field="RunMonDesc"></p-sortIcon></th>
					<th pSortableColumn="RunTueDesc" class="fixwidth-09">Tuesday<p-sortIcon field="RunTueDesc"></p-sortIcon></th>
					<th pSortableColumn="RunWedDesc" class="fixwidth-09">Wednesday<p-sortIcon field="RunWedDesc"></p-sortIcon></th>
					<th pSortableColumn="RunThuDesc" class="fixwidth-09">Thursday<p-sortIcon field="RunThuDesc"></p-sortIcon></th>
					<th pSortableColumn="RunFriDesc" class="fixwidth-09">Friday<p-sortIcon field="RunFriDesc"></p-sortIcon></th>
					<th pSortableColumn="RunSatDesc" class="fixwidth-09">Saturday<p-sortIcon field="RunSatDesc"></p-sortIcon></th>
					<th pSortableColumn="RunSunDesc" class="fixwidth-09">Sunday<p-sortIcon field="RunSunDesc"></p-sortIcon></th>
					<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-JobSchedule>
				<tr [pSelectableRow]="JobSchedule" (dblclick)="onRowDblClick(JobSchedule)">
					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ JobSchedule.RunTimeDesc }}
					</td>

					<td class="fixwidth-09">
						<div class="CheckDiv">
							<i *ngIf="JobSchedule.RunMon == true" class="pi pi-check-circle table-active"></i>
							<i *ngIf="JobSchedule.RunMon == false" class="pi pi-ban table-inactive"></i>
						</div>
					</td>

					<td class="fixwidth-09">
						<div class="CheckDiv">
							<i *ngIf="JobSchedule.RunTue == true" class="pi pi-check-circle table-active"></i>
							<i *ngIf="JobSchedule.RunTue == false" class="pi pi-ban table-inactive"></i>
						</div>
					</td>

					<td class="fixwidth-09">
						<div class="CheckDiv">
							<i *ngIf="JobSchedule.RunWed == true" class="pi pi-check-circle table-active"></i>
							<i *ngIf="JobSchedule.RunWed == false" class="pi pi-ban table-inactive"></i>
						</div>
					</td>

					<td class="fixwidth-09">
						<div class="CheckDiv">
							<i *ngIf="JobSchedule.RunThu == true" class="pi pi-check-circle table-active"></i>
							<i *ngIf="JobSchedule.RunThu == false" class="pi pi-ban table-inactive"></i>
						</div>
					</td>

					<td class="fixwidth-09">
						<div class="CheckDiv">
							<i *ngIf="JobSchedule.RunFri == true" class="pi pi-check-circle table-active"></i>
							<i *ngIf="JobSchedule.RunFri == false" class="pi pi-ban table-inactive"></i>
						</div>
					</td>

					<td class="fixwidth-09">
						<div class="CheckDiv">
							<i *ngIf="JobSchedule.RunSat == true" class="pi pi-check-circle table-active"></i>
							<i *ngIf="JobSchedule.RunSat == false" class="pi pi-ban table-inactive"></i>
						</div>
					</td>

					<td class="fixwidth-09">
						<div class="CheckDiv">
							<i *ngIf="JobSchedule.RunSun == true" class="pi pi-check-circle table-active"></i>
							<i *ngIf="JobSchedule.RunSun == false" class="pi pi-ban table-inactive"></i>
						</div>
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="JobSchedule.Active == true ? 'Black' : 'Red'">
						{{ JobSchedule.ActiveDesc }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>

	<!--Error Message-->
	<div class="TopMargin">
		<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
	</div>
</div>
